import styled from 'styled-components'
import { components } from 'react-select'

import colors from 'components/utils/colors'
import { InnerComponent } from 'components/utils/innerReactSelectComponents'

import { StyledDropdownIndicator } from './DropdownIndicator'
import { StyledClearIndicator } from './ClearIndicator'
import { StyledDirectionSection } from '../DirectionIcon'

const StyledControl = styled(InnerComponent).attrs({ Component: components.Control })`
  &.react-select__control {
    font-size: 12px;
    line-height: 16px;
    min-height: 16px;
    box-shadow: none;
    cursor: pointer;
    border-style: none;
    flex-wrap: nowrap;
  }

  &:hover, &.react-select__control--menu-is-open {
    ${StyledDropdownIndicator} {
      color: ${colors.primary40};
    }
  }

  /* do not highlight Dropdown Indicator when hovering Clear Indicator */
  &:not(.react-select__control--menu-is-open) {
    ${StyledClearIndicator}:hover {
      & ~ ${StyledDropdownIndicator} {
        color: unset !important;
      }
    }
  }

  /* do not highlight Dropdown Indicator when hovering Clear Indicator */
  &:not(.react-select__control--menu-is-open) {
    ${StyledDirectionSection}:hover {
      & ~ ${StyledDropdownIndicator} {
        color: unset !important;
      }
    }
  }

  &.react-select__control--is-disabled {
    background-color: #FFFFFF;

    .react-select__placeholder {
      color: ${colors.secondary80};
    }
  }

  .react-select__placeholder {
    color: ${colors.secondary20};
  }
`

const SelectControl = (props) => {
  return (
    <StyledControl {...props} />
  )
}

export default SelectControl
